<template>
  <div class="dropdown">
    <div class="dropdown__content">
      <button class="dropdown__button" @click="isActive = !isActive">
        {{ label }} <IconChevronDown :class="{ 'is-active': isActive }" />
      </button>
      <div v-show="isActive" class="dropdown__options">
        <slot></slot>
      </div>
    </div>
    <div class="dropdown__mask" @click="isActive = false" v-show="isActive"></div>
  </div>
</template>

<script>
import { IconChevronDown } from "@/components/ui/icons";

export default {
  data() {
    return {
      isActive: false,
    };
  },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  components: {
    IconChevronDown,
  },
};
</script>

<style lang="scss">
.dropdown {
  display: inline-block;

  &__mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
  }

  &__content {
    position: relative;
    display: inline-block;
  }

  &__button {
    background: #fbfbfb;
    border: 1px solid #e1e1e1;
    font-size: 14px;
    line-height: 1;
    display: inline-flex;
    gap: 8px;
    align-items: center;
    padding: 10px 16px;
    border-radius: 20px;
    color: #7d7d7d;
    font-weight: bold;
    cursor: pointer;

    .is-active {
      transform: rotate(180deg);
    }
  }

  &__options {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background-color: white;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    z-index: 100;
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px;
    border-radius: 20px;
  }

  &__item {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 8px 16px;
    font-size: 1rem;
    gap: 12px;
    border: 0;
    border-radius: 8px;
    white-space: nowrap;
    color: #000;
    cursor: pointer;

    &:hover {
      background: #f7f7f7;
    }
  }

  &__icon {
    width: 32px;
    height: 32px;
    padding: 8px;
    box-sizing: border-box;
    background: #ebf8fa;
    border-radius: 8px;
    color: #158491;

    &--red {
      background: #fde8e8 !important;
      color: #e55353 !important;
    }
  }

  hr {
    margin: 0;
  }
}
</style>